import * as React from 'react';
import { DomainLogo } from './domain-logo';
import { ISearchResult } from '../../state-helpers/search-results';
import { IEpiProps } from '../../state-helpers/epi-props';
import { Lock } from './lock';
import { MediaIcon } from './media-icon';
import { showIssueNumber, showPublicationName, showPublishDate, showShortDescription, showVolumeNumber } from './shared/results-helpers';
import { SearchResultLabels } from './shared/search-result-labels';

interface IProps {
    result: ISearchResult;
    epiProps: IEpiProps;

    onClick: () => void;
}

export class SearchResultBestBet extends React.Component<IProps, any> {
    render() {
        let { result, epiProps } = this.props;
        return (
            <div className="search-result-wrapper-best-bet">
                <a className="search-result search-result-all-aap" href={result.url} onClick={this.props.onClick}>
                    <div className="search-result-header">

                        <div className="search-result-title-best-bet" dangerouslySetInnerHTML={{ __html: result.title }} />
                        <DomainLogo url={result.friendlyUrl} />
                    </div>

                    {(showPublicationName(result) || showVolumeNumber(result) || showIssueNumber(result)) &&
                        <div className="search-result-meta">
                        {(showPublicationName(result)) && <span className="search-result-meta-publication">{result.publicationName}</span>}

                        {(showPublicationName(result) && showVolumeNumber(result)) && <span className="middle-dot">&middot;</span>}

                        {(showVolumeNumber(result)) && <span className="search-result-meta-volume">Volume {result.volumeNumber}</span>}

                        {(showVolumeNumber(result) && showIssueNumber(result)) && <span className="middle-dot">&middot;</span>}

                        {(showIssueNumber(result)) && <span className="search-result-meta-number">Number {result.issueNumber}</span>}
                        </div>
                    }

                    {(showPublishDate(result) || showShortDescription(result)) &&
                        <div className="search-result-excerpt">
                        {showPublishDate(result) &&
                                <span>
                                    <span className="search-result-excerpt-date">{result.publishDate.toString()}</span>
                                        {showShortDescription(result) &&
                                        <span className="middle-dot">&middot;</span>
                                    }
                                </span>
                        }
                        {showShortDescription(result) &&
                            <span className="search-result-content" dangerouslySetInnerHTML={{ __html: result.shortDescription }}></span>
                        }
                        </div>
                    }

                    <SearchResultLabels
                        result={result}
                        epiProps={epiProps}
                    />

                    <div className="search-result-link">
                        {result.iconType &&
                            <MediaIcon type={result.iconType} />
                        }
                        <Lock url={result.url} />
                        <u>{result.friendlyUrl}</u>
                    </div>

                </a>
            </div>
        )
    }
}